import { COMPONENT_TYPE } from '@/components/glms/js/const'
import $store from '@/store'

export const PromptParseErrorMsg = 'Parse Error!'
export const getPromptStructure = (openingPromp, defaultStructure) => {
  if (openingPromp && openingPromp !== defaultStructure) {
    return openingPromp
  } else {
    return defaultStructure
  }
}
const getValue = item => {
  if (item.type === COMPONENT_TYPE.singleLine || item.type === COMPONENT_TYPE.multiLine) {
    return `「用户输入的内容」`
  }
  if (item.type === COMPONENT_TYPE.tag || item.type === COMPONENT_TYPE.select) {
    return `「${item?.options?.[0]}」` || `「用户选择的内容」`
  }
  return `「用户输入的内容」`
}
const getRealValue = item => {
  return item?.content || ''
}
function hasAtLeastOneBalancedPair(str) {
  const stack = []
  let hasOpenBracket = false
  let hasBalancedPair = false

  for (let i = 0; i < str.length; i++) {
    if (str[i] === '{') {
      stack.push('{')
      hasOpenBracket = true
    } else if (str[i] === '}') {
      if (stack.length === 0) {
        // 如果栈为空，则遇到未匹配的右大括号
        return false
      }
      // 弹出栈顶的左大括号
      stack.pop()
      if (stack.length === 0) {
        // 如果栈再次为空，并且之前有左大括号，则表示有一对正确闭合的大括号
        hasBalancedPair = true
      }
    }
  }
  // 如果栈不为空，则有大括号未闭合
  if (stack.length > 0) {
    return false
  }
  // 确保至少有一对双大括号
  return hasBalancedPair
}

export const getPromptByStructure = (structure = '', list = [], hasValue = false) => {
  if (!hasAtLeastOneBalancedPair(structure)) {
    return [PromptParseErrorMsg]
  }

  const modifiedStructure = structure
    .replaceAll('{{', '{')
    .replaceAll('}}', '}')
    .replaceAll(/<\/?wise[^>]*>/g, '')
  /**
   * curSubstring, 记录每个成对{}中间的字符串
   */
  const queue = []
  const arr = []
  let curSubstring = ''
  for (let index = 0; index < modifiedStructure.length; index++) {
    const element = modifiedStructure[index]
    if (element === '{') {
      queue.push(element)
      if (curSubstring.length > 0) {
        arr.push({
          type: 'pure',
          value: curSubstring
        })
        curSubstring = ''
      }
    } else if (element === '}') {
      if (queue.length > 0 && queue.pop() === '{') {
        if (queue.length === 0) {
          arr.push({
            type: 'key',
            value: curSubstring
          })
          curSubstring = ''
        } else {
          return PromptParseErrorMsg
        }
      } else {
        return PromptParseErrorMsg
      }
    } else {
      curSubstring += element
    }
  }
  if (curSubstring.length > 0) {
    arr.push({
      type: 'pure',
      value: curSubstring
    })
  }

  if (arr.length <= 0) return []
  const keyList = list.map(l => l.key)
  const result = arr.map(item => {
    if (item.type === 'key') {
      const key = item.value
      // key值正确形式：{{key1}}
      if (!keyList.includes(key)) return PromptParseErrorMsg
      // 值用变量形式
      const curItem = list.find(comp => comp.key === key)
      return [
        // {
        //   type: 'pure',
        //   value: curItem ? `${curItem.title}` : ''
        // },
        {
          type: 'key',
          value: hasValue ? getRealValue(curItem) : getValue(curItem)
        }
      ]
    } else {
      return item
    }
  })
  return result.flat() || []
}
export const getRealPromptByStructure = () => {
  const assistantInfo = $store.state.Glms.assistantInfo
  const uiComponents = $store.getters['Glms/uiComponents']
  const defaultPromptStructure = $store.getters['Glms/uiDefaultPrompt']
  const opening_prompt = assistantInfo.opening_ui?.opening_prompt
  const structure = opening_prompt || defaultPromptStructure
  const promptStructure = getPromptByStructure(structure, uiComponents, true)
  return promptStructure
    .map(prom => prom.value)
    .join('')
    .replace(/(^\u0020*)|(\u0020*$)/g, '')
}

export const getTypeText = type => {
  switch (type) {
    case COMPONENT_TYPE.singleLine:
      return '单行文本'
    case COMPONENT_TYPE.multiLine:
      return '多行文本'
    case COMPONENT_TYPE.tag:
      return '分类'
    case COMPONENT_TYPE.paragraph:
      return '文本段落'
    case COMPONENT_TYPE.select:
      return '下拉选项'
    default:
      return ''
  }
}

export function checkBrowser() {
  var userAgent = navigator.userAgent.toLowerCase()

  if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edge') === -1) {
    return 'Chrome'
  } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
    return 'Safari'
  } else if (userAgent.indexOf('edge') > -1) {
    return 'Edge'
  } else {
    return 'Other'
  }
}

function generateUniqueId() {
  return `r${new Date().getTime()}d${Math.ceil(Math.random() * 1000)}`
}
function replacer(match, p1, p2, p3, offset, string) {
  const curId = generateUniqueId()
  return `<wise id="${curId}${p1}">{{${p1}}}</wise>`
}
export function promptReplacer(originalStr = '') {
  return originalStr.replaceAll(/<\/?wise[^>]*>/g, '').replaceAll(/\{\{(.*?)\}\}/g, replacer)
}
